import BigNumber from "bignumber.js";
import { ethers } from "ethers";
import LendingPoolConfigurator from "src/assets/abis/poolMonitoring/LendingPoolConfigurator.json";
import PoolUpdateControl from "src/assets/abis/poolMonitoring/PoolUpdateControl.json";
import ProviderFactory from "src/assets/abis/poolMonitoring/ProviderFactory.json";
import factoryRegistry from "src/assets/abis/poolMonitoring/FactoryRegistry.json";
import ReserveInterestRateFactory from "src/assets/abis/poolMonitoring/ReserveInterestRateFactory.json";
import { getNetworkContractAddresses } from "src/config/addresses";
import { NETWORK } from "src/config/constants";

export const base = new BigNumber(10).pow(4).toNumber();
export const base27 = new BigNumber(10).pow(27).toString();

const contractAddress = getNetworkContractAddresses(NETWORK.BSC_TESTNET);

export const getContractEditPool = (provider) => {
  const contract = new ethers.Contract(contractAddress.POOL_UPDATE_CONTROLLER, PoolUpdateControl, provider);
  return contract;
};

export const getContractAddressProviderFactory = (provider) => {
  const contract = new ethers.Contract(contractAddress.ADDRESS_PROVIDER_FACTORY, ProviderFactory, provider);
  return contract;
};

export const getContractLendingPoolConfigurator = (provider, contractAddress) => {
  const contract = new ethers.Contract(contractAddress, LendingPoolConfigurator, provider);
  return contract;
};

export const getContractGenerateInterestRateStrategyAddress = (provider, address) => {
  const contract = new ethers.Contract(address, ReserveInterestRateFactory, provider);
  return contract;
};

export const getContractFactoryRegistry = (provider) => {
  const contract = new ethers.Contract(contractAddress.FACTOR_REGISTRY_ADDRESS, factoryRegistry, provider);
  return contract;
};

export const encodePackageData = async (provider, type, value) => {
  const contract = new ethers.Contract(
    contractAddress.POOL_CONFIGURATOR_LOGIC_ADDRESS,
    LendingPoolConfigurator,
    provider
  );
  const data = await contract.interface.encodeFunctionData(type, value);
  return data;
};
